import React from "react";
import "./Mentor.css";

const Mentor = () => {
  return (
    <div className="mentor-container">
      <div className="mentor-card">
        <h1 className="mentor-title">Mentorship Program</h1>
        <p className="mentor-subtitle">
          Something exciting is on the way
        </p>

        <div className="coming-soon">
          🚀 Coming Soon
        </div>

        <p className="mentor-description">
          We’re building a powerful mentorship experience to connect industry
          leaders with aspiring professionals.
        </p>
      </div>
    </div>
  );
};

export default Mentor;
